module.exports = __webpack_public_path__ + "static/media/03.e7b3da84.mp3";